import { IServiceRequest, ServiceRequestStatus } from "../models";

import { useServiceRequestContext } from "../service-request";
import { useState } from "react";

export const ServiceRequestResend = ({ serviceRequest }: { serviceRequest: IServiceRequest }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingModify, setLoadingModify] = useState<boolean>(false);
    const { resendApprovalRequest, resetRequestStatusToDraft } = useServiceRequestContext()

    const handleResend = () => {
        setLoading(true)
        resendApprovalRequest(serviceRequest.id)
            .finally(() => setLoading(false))
    }

    const handleModification = () => {
        setLoadingModify(true)
        resetRequestStatusToDraft(serviceRequest.id)
            .finally(() => setLoadingModify(false))
    }

    if (serviceRequest.statusCode !== ServiceRequestStatus.Submitted || !serviceRequest.endTime)
        return <></>

    return (
        <div>
            <div className="d-flex gap-3">
                <button
                    type="button" className="btn btn-sm btn-success py-2" onClick={handleModification} disabled={loadingModify}>
                    {loadingModify ?
                        <span className='indicator-progress' style={{ display: 'inline-block' }}>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                        : <>
                            <span className='indicator-label'>
                                Resend for modification
                            </span>
                        </>}
                </button>
                <button
                    type="button" className="btn btn-sm btn-warning py-2" onClick={handleResend} disabled={loading}>
                    {loading ?
                        <span className='indicator-progress' style={{ display: 'inline-block' }}>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                        : <>
                            <span className='indicator-label'>
                                Resend for approval
                            </span>
                        </>}
                </button>
            </div>
        </div>
    )
}
